import { createApi } from "@reduxjs/toolkit/query/react";

import { axiosBaseQuery } from "../../lib/domain/axiosBaseQuery";

const dialxyApi = createApi({
  reducerPath: "dialxyApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    "Contact",
    "CallLog",
    "DialerLogs",
    "Message",
    "ReserveNumber",
    "ReserveVoipNumber",
    "Profile",
    "Subscription",
    "SubscriptionDetails",
    "Number",
    "Voicemail",
    "Credit",
    "Agent",
    "Device",
    "QRCode",
    "DialNumber",
    "Settings",
    "Country",
    "ivr",
    "Blocklist",
    "CRM",
  ],
  endpoints: () => ({}),
});

export default dialxyApi;
